import type {
	AdfValue,
	DateTimeValue,
	DateValue,
	FieldValue,
	FilesValue,
	LocalTimeValue,
	ModifiedFieldValue,
	ModifiedFilesValue,
	NumberValue,
	OptionsValue,
	TextValue,
} from './index';

export const asAdfValue = (fieldValue?: FieldValue): AdfValue | undefined =>
	fieldValue && 'adf' in fieldValue ? (fieldValue as AdfValue) : undefined;

export const asDateTimeValue = (fieldValue?: FieldValue): DateTimeValue | undefined =>
	fieldValue && ('date' in fieldValue || 'localTime' in fieldValue)
		? (fieldValue as DateTimeValue)
		: undefined;

export const asDateValue = (fieldValue?: FieldValue): DateValue | undefined =>
	fieldValue && 'date' in fieldValue && !('localTime' in fieldValue)
		? (fieldValue as DateValue)
		: undefined;

export const asFilesValue = (fieldValue?: FieldValue): FilesValue | undefined =>
	fieldValue && 'files' in fieldValue ? (fieldValue as FilesValue) : undefined;

export const asLocalTimeValue = (fieldValue?: FieldValue): LocalTimeValue | undefined =>
	fieldValue && 'localTime' in fieldValue && !('date' in fieldValue)
		? (fieldValue as LocalTimeValue)
		: undefined;

export const asModifiedFilesValue = (
	fieldValue?: ModifiedFieldValue,
): ModifiedFilesValue | null | undefined =>
	fieldValue && 'fileStatus' in fieldValue
		? (fieldValue as ModifiedFilesValue)
		: fieldValue === null
			? null
			: undefined;

export const asNumberValue = (fieldValue?: FieldValue): NumberValue | undefined =>
	fieldValue && 'number' in fieldValue ? (fieldValue as NumberValue) : undefined;

export const asOptionsValue = (fieldValue?: FieldValue): OptionsValue | undefined =>
	fieldValue && 'options' in fieldValue ? (fieldValue as OptionsValue) : undefined;

export const asTextValue = (fieldValue?: FieldValue): TextValue | undefined =>
	fieldValue && 'text' in fieldValue ? (fieldValue as TextValue) : undefined;

export const isOptionsValue = (val: FieldValue): val is OptionsValue =>
	asOptionsValue(val) !== undefined;

export const isNumberValue = (val: FieldValue): val is NumberValue =>
	asNumberValue(val) !== undefined;

export const isDateValue = (val: FieldValue): val is DateValue => asDateValue(val) !== undefined;

export const isDateTimeValue = (val: FieldValue): val is DateTimeValue =>
	asDateTimeValue(val) !== undefined;

export const isLocalTimeValue = (val: FieldValue): val is LocalTimeValue =>
	asLocalTimeValue(val) !== undefined;

export const isTextValue = (val: FieldValue): val is TextValue => asTextValue(val) !== undefined;

export const isAdfValue = (val: FieldValue): val is AdfValue => asAdfValue(val) !== undefined;
